/** @file The mesh the active mesh tool resolved (the Weights panel follows it; null when no mesh tool runs). */
import type { Id } from '@pose2d/format/types';
import { createStore } from 'zustand/vanilla';

/** Slot and attachment ids of the mesh being edited or painted. */
export interface MeshTargetState {
  target: { slot: Id; attachment: Id } | null;
}

/** Written by the editMesh and paintWeights sessions; cleared when they end. */
export const meshTargetStore = createStore<MeshTargetState>()(() => ({ target: null }));
